import React from "react";
import TextField from "@mui/material/TextField";

export const BaseTextField = ({ readOnly = false, ...props }) => {
  return (
    <TextField
      id="outlined-basic"
      variant="outlined"
      size="small"
      InputProps={{
        readOnly,
      }}
      {...props}
    />
  );
};
